import React, { FC, useState } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { getTCConnection } from "../repositories/TCRepository";
import { FullScreenLoader } from "../Components/Loader";
import { axiosConnectorInstance } from "../App";
import { logOut } from "../utils/AxiosHandlers";
import { Alert, Button as MuiButton } from "@mui/material";

export const TCLogin: FC = () => {
  const [connectionName, setConnectionName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const authToken = localStorage.getItem("infrakitToken");
    const infrakitAccessToken = JSON.parse(authToken || "{}").accessToken;
    !infrakitAccessToken && navigate("/");

    const connectionUuid = localStorage.getItem("connectionUuid");
    !connectionUuid && navigate("/");

    setIsLoading(true);
    getTCConnection(connectionUuid!)
      .then((data) => {
        setConnectionName(data.name);
        !!data.loggedInTC && navigate("/trimble/projects");
      })
      .finally(() => setIsLoading(false));
  }, [navigate]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const connectionUuid = localStorage.getItem("connectionUuid");

    const client_id = data.get("client_id");
    const client_secret = data.get("client_secret");

    axiosConnectorInstance("/state", {
      method: "post",
      data: {
        client_id: client_id,
        client_secret: client_secret,
        connectionUuid: connectionUuid,
      },
    }).then((res) => {
      console.log(res.data);

      const REACT_APP_TRIMBLE_AUTH_URL = process.env.REACT_APP_TRIMBLE_AUTH_URL;
      const REACT_APP_TRIMBLE_RESPONSE_TYPE =
        process.env.REACT_APP_TRIMBLE_RESPONSE_TYPE;
      const REACT_APP_TRIMBLE_REDIRECT_URI =
        process.env.REACT_APP_TRIMBLE_REDIRECT_URI;
      const REACT_APP_TRIMBLE_SCOPE = process.env.REACT_APP_TRIMBLE_SCOPE;
      window.open(
        REACT_APP_TRIMBLE_AUTH_URL +
          "?client_id=" +
          client_id +
          "&response_type=" +
          REACT_APP_TRIMBLE_RESPONSE_TYPE +
          "&redirect_uri=" +
          REACT_APP_TRIMBLE_REDIRECT_URI +
          "&scope=" +
          REACT_APP_TRIMBLE_SCOPE +
          "&state=" +
          res.data.state,
        "_self"
      );
    });
  };

  return (
    <div>
      <div className="header-button-container">
        <div>
          <MuiButton
            variant="contained"
            className="header-button"
            onClick={logOut}
          >
            Logout
          </MuiButton>
          <MuiButton
            variant="contained"
            className="header-button"
            onClick={() => {
              localStorage.removeItem("connectionUuid");
              localStorage.removeItem("infrakitProjectUuid");
              navigate("/infrakit/projects");
            }}
          >
            Change Infrakit Project
          </MuiButton>
          <MuiButton
            variant="contained"
            className="header-button"
            onClick={() => {
              localStorage.removeItem("connectionUuid");
              navigate("/connections");
            }}
          >
            Change connection
          </MuiButton>
        </div>
      </div>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h1>Connection name: {connectionName}</h1>
          <img
            src="https://connect.trimble.com/themes/trimble_connect/connect-logo.svg"
            alt="logo"
          />

          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <Alert severity="warning" sx={{ mt: 1, mb: 1 }}>
              This should be provided by TC customer support.
            </Alert>
            <TextField
              margin="normal"
              required
              fullWidth
              id="client_id"
              label="Trimble Connect Client ID"
              name="client_id"
              autoComplete="client_id"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="client_secret"
              label="Trimble Connect Client Secret"
              type="password"
              id="client_secret"
              autoComplete="client_secret"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Login
            </Button>
          </Box>
        </Box>
        {isLoading && <FullScreenLoader isLoading />}
      </Container>
    </div>
  );
};
